import MongoModel from './MongoModel'
import { between, date, gte, isblank, isnull, required, string } from 'vue-mc/validation'

export default class Activity extends MongoModel {
  modelName = 'Activity'
  collection = 'activities'
  autoFields = true

  defaults () {
    return {
      id: null,
      organization: null,
      parentId: null,
      name: null,
      owner: null,
      startDate: null,
      dueDate: null,
      effort: 0,
      progress: 0,
      order: 0,
      successors: {}
    }
  }

  mutations () {
    return {
    }
  }

  validation () {
    return {
      name: required.and(string),
      startDate: date.or(isnull.or(isblank)),
      dueDate: date.or(isnull.or(isblank)),
      effort: gte(0),
      progress: between(0, 100),
      order: gte(0)
    }
  }
}
